'use client';

import useDlobAutoSwitchSource from './useDlobAutoSwitchSource';
import useSyncAccountLoaderCadenceWithMarketSubs from './useSyncAccountLoaderCadenceWithMarketSubs';
import useSyncMarketDataWithBlockchain from './useSyncMarketDataWithBlockchain';
import useSyncMarketDataWithDlobServerPolling from './useSyncMarketDataWithDlobServerPolling';
import useSyncMarketSubscriptions from './useSyncMarketSubscriptions';

const useSyncMarketDataState = () => {
	useSyncMarketSubscriptions();

	// These hooks handle syncing market data (market state store) depending on the selected data source
	useSyncMarketDataWithDlobServerPolling();
	useSyncMarketDataWithBlockchain();

	// This hook handles switching the dlob source if it detects bad health
	useDlobAutoSwitchSource();

	useSyncAccountLoaderCadenceWithMarketSubs();
};

export default useSyncMarketDataState;
